<template>
  <layout>
    <page-header :header="$t('general.edit')" />
    <div class="content">
      <resource-form
        :id="$route.params.id"
        :show-cancel-button="true"
        @deleted="returnBack"
        @accepted="onAccept"
      />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'company-applications'

export default {
  name: 'CompanyApplicationEdit',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
    onAccept(company) {
      this.$router.push({ name: 'companies.edit', params: { id: company.id } })
    },
  },
}
</script>
